import React, { useCallback, useState, useMemo } from 'react'
import ModalBtns from '@groovehq/internal-design-system/lib/components/ModalBtns/ModalBtns'
import ButtonList from '@groovehq/internal-design-system/lib/components/ButtonList/ButtonList'
import { AdminAccessDrawer } from 'subapps/settings/components/drawers/NoAccess'
import { useDrawer } from 'ducks/drawers/hooks'
import { buildDrawerQueryParam } from 'ducks/drawers/util'
import HeaderWithImage from '@groovehq/internal-design-system/lib/components/HeaderWithImage/HeaderWithImage'
import { CHANNEL_MAIN_TYPES } from '../Channels.data'

const AddChannelDrawer = ({ onExit }) => {
  const [selectedChannel, setSelectedChannel] = useState('email')

  const { drawerId: nextDrawerId, openDrawer: openNextDrawer } = useDrawer(
    CHANNEL_MAIN_TYPES[selectedChannel].drawer
  )

  const channelList = useMemo(() => {
    return Object.keys(CHANNEL_MAIN_TYPES).map(type => {
      const channel = {
        type,
        ...CHANNEL_MAIN_TYPES[type],
      }
      return channel
    })
  }, [])

  const handleOpenNextDrawer = useCallback(
    () => {
      openNextDrawer('new', {
        query: {
          ...buildDrawerQueryParam(
            nextDrawerId,
            'drawerChannelType',
            selectedChannel
          ),
        },
      })
    },
    [openNextDrawer, selectedChannel, nextDrawerId]
  )

  const footer = (
    <ModalBtns saveBtnText="Next step" onSave={handleOpenNextDrawer} />
  )

  return (
    <AdminAccessDrawer title="Add a channel" footer={footer} onClose={onExit}>
      <HeaderWithImage
        className="grui mt-14 mb-12"
        title="Choose a channel"
        intro="Let's get your conversations flowing into Groove."
      />
      <ButtonList
        list={channelList}
        onSelect={setSelectedChannel}
        selected={selectedChannel}
      />
    </AdminAccessDrawer>
  )
}
export default AddChannelDrawer
